module.exports = __webpack_public_path__ + "static/img/5.8b1d95f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/5.png
// module id = 7yul
// module chunks = 0